import React from 'react'
import { bool, oneOf } from 'prop-types'

import CheckoutButton from '../CheckoutButton'
import SubscriptionInfo from './SubscriptionInfo'

const SummaryAction = ({ disabled, size = 'large' }) => {
  return (
    <div id="action-btn-cart">
      <CheckoutButton fullWidth size={size} disabled={disabled} />
      {size !== 'compact' && !disabled && <SubscriptionInfo />}
    </div>
  )
}

SummaryAction.propTypes = {
  disabled: bool,
  size: oneOf(['large', 'compact']),
}

export default SummaryAction
